enum AccessoryDisabledReason {
  MaxExceeded = 'maxExceeded',
}

export default AccessoryDisabledReason;
